import { DropdownItemType } from '../enums';
import { DropdownItem } from '@app/components/header/models/header.model';

export const dropdownItems: DropdownItem[] = [
  {
    icon: 'assignment.svg',
    type: DropdownItemType.PR
  },
  {
    icon: 'gavel.svg',
    type: DropdownItemType.TenderReduction
  },
  {
    icon: 'handshake.svg',
    type: DropdownItemType.Agreement
  },
  {
    icon: 'receipt.svg',
    type: DropdownItemType.Order
  },
  {
    icon: 'receipt.svg',
    type: DropdownItemType.Receipt
  },
  {
    icon: 'task.svg',
    type: DropdownItemType.Task
  },
  {
    icon: 'description.svg',
    type: DropdownItemType.Document
  },
  {
    icon: 'rebase.svg',
    type: DropdownItemType.Process
  },
  {
    icon: 'master.svg',
    type: DropdownItemType.Master
  }
];
